(function(){
    var categoryFilters = document.querySelectorAll('.category-filter')
    categoryFilters.forEach(function(categoryFilter) {
        categoryFilter.querySelector('.filter-button').addEventListener('click', function(){
            if (categoryFilter.classList.contains('dd-open')) {
                categoryFilter.classList.remove('dd-open');
            } else {
                const openDiv = document.querySelector('.dd-open');
                openDiv && openDiv.classList.remove('dd-open');
                categoryFilter.classList.add('dd-open');
            }
        });

        // Add event listener to the document to detect clicks outside the category filter
        document.addEventListener("click", function (event) {
            if (!event.target.closest('.dd-open')) {
                categoryFilter.classList.remove("dd-open");
            }
        });
    })

    // Set the title text
    categoryFilters.forEach(function(categoryFilter) {
        var filterItems = categoryFilter.querySelectorAll('.filter-item');
        filterItems.forEach(function(filterItem){
            if (filterItem.textContent === window.collection_title) {
                categoryFilter.querySelector('.filter-button').childNodes[0].nodeValue = window.collection_title;
            }
        })
    });
})()